module.exports = __webpack_public_path__ + "static/media/completed-status.2687ddae.svg";